import { AxiosPromise } from 'axios';
import HTTP from '../services/http';
import {
  ISignatureRequirement,
  ICreateSignatureRequirementRequest,
  ISignatureRequirementListResponse,
  IListFilters,
} from '../models/signature-requirement/types';

// ⚠️ Do NOT prefix with '/api' — the HTTP service baseURL already includes '/api'
// Adding '/api' here would result in a doubled path: /api/api/signature-requirement
const baseUrl = '/signature-requirement';

export class SignatureRequirementClient {
  /**
   * Create a new signature requirement rule
   */
  static create(data: ICreateSignatureRequirementRequest): AxiosPromise<ISignatureRequirement> {
    return HTTP.post(baseUrl, data);
  }

  /**
   * List all signature requirement rules for a customer.
   * Sends `trigger_type` to the API when exactly one type is selected (not 'all').
   * When multiple types or 'all' is selected, `trigger_type` is omitted — API returns all rules.
   * Always called after debouncing by the caller (index.tsx → SignatureRequirementTable).
   */
  static list(
    customerId: number,
    filters?: IListFilters,
  ): AxiosPromise<ISignatureRequirementListResponse> {
    const params: Record<string, string> = {
      customer_id: customerId.toString(),
    };

    if (filters?.search) {
      params.search = filters.search;
    }

    if (filters?.trigger_type) {
      params.trigger_type = filters.trigger_type;
    }

    return HTTP.get(baseUrl, { params });
  }

  /**
   * Bulk delete signature requirement rules
   */
  static delete(ids: number[]): AxiosPromise<{ deleted: number }> {
    return HTTP.post(`${baseUrl}/delete`, { ids });
  }
}
